import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { MaterialModule } from '@shared/angular-material';

import { BeeBackButtonComponent } from './bee-back-button.component';

@NgModule({
  declarations: [
    BeeBackButtonComponent
  ],
  imports: [
    CommonModule,
    MaterialModule
  ],
  exports: [
    BeeBackButtonComponent
  ]
})
export class BeeBackButtonModule { }
